import React, { Component, PropTypes } from 'react';
import axios from 'axios';
import { Col, ControlLabel, FormGroup } from 'react-bootstrap';
import config from '../../../../config/config';

const appUrlPath = `/${config.appUrlPath}`;

class CoverNoteStatus extends Component {

  constructor(props) {
    super(props);
    this.state = {
      option: []
    }
  }

  componentWillMount() {
    axios.get(`${appUrlPath}/getCoverNoteStatus`, {
      params: {}
    })
    .then((res) => {
      this.setState({ option: res.data });
    })
    .catch(() => {
    });
  }

  render() {
    return (
      <FormGroup controlId="coverNoteStatus">
        <Col componentClass={ControlLabel} sm={4}>
          Cover Note Status
        </Col>
        <Col sm={8}>
          <select
            className="custom-select"
            onChange={this.props.handleChangeCoverNoteStatus}
            value={this.props.coverNoteStatus}
            id="coverNoteStatus"
          >
            <option value="">Please Select</option>
            {this.state.option.map((obj, index) => {
              const counter = index;
              return (
                <option
                  value={obj.code}
                  key={counter}
                >{obj.name}</option>
              );
            })}
          </select>
        </Col>
      </FormGroup>
    )
  }
}

CoverNoteStatus.propTypes = {
  handleChangeCoverNoteStatus: PropTypes.func,
  coverNoteStatus: PropTypes.string
};

export default CoverNoteStatus;



// WEBPACK FOOTER //
// ./src/app/components/retrieveCoverNoteComponent/coverNoteStatus/CoverNoteStatus.js